"use client"

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { FileText, ExternalLink } from "lucide-react"
import { MarkdownRenderer } from "../MarkdownRenderer"
import { useReportPanel } from "../ReportPanelContext"
import { AiWarningBanner } from "../AiWarningBanner"

interface ReportWidgetProps {
  title: string
  executiveSummary: string
  fullReportMarkdown: string
}

export function ReportWidget({ title, executiveSummary, fullReportMarkdown }: ReportWidgetProps) {
  const { openReport } = useReportPanel()

  return (
    <Card className="my-3 border-primary/20 shadow-md max-w-3xl">
      <CardHeader className="pb-2 pt-4 px-5">
        <div className="flex items-center gap-2">
          <FileText className="h-5 w-5 mb-1 text-primary shrink-0" />
          <div className="flex-1 min-w-0">
            <CardTitle className="text-lg font-semibold leading-tight">{title}</CardTitle>
          </div>
        </div>
      </CardHeader>
      <CardContent className="px-5 pb-4 pt-0 space-y-3">
        <div className="border-l-2 border-primary/30 pl-3">
          <p className="text-xs font-medium text-muted-foreground uppercase tracking-wide mb-1">
            Executive Summary
          </p>
          <div className="text-sm text-foreground prose prose-sm max-w-none">
            <MarkdownRenderer content={executiveSummary} />
          </div>
        </div>

        <AiWarningBanner />

        <Button
          variant="outline"
          size="sm"
          onClick={() =>
            openReport({
              kind: "report",
              title,
              summary: executiveSummary,
              markdown: fullReportMarkdown,
            })
          }
          className="text-xs gap-1.5"
        >
          <ExternalLink className="h-3 w-3" />
          Open full report
        </Button>
      </CardContent>
    </Card>
  )
}